import classNames from 'classnames';
import { LegacyRef, forwardRef } from 'react';
import * as React from 'react';

interface ToggleInputProps extends React.HTMLProps<HTMLInputElement> {
  id: string;
  label: string;
  description?: string;
  checked?: boolean;
}

const ToggleInput = forwardRef(
  (props: ToggleInputProps, ref: LegacyRef<HTMLInputElement>) => {
    const { id, label, disabled, description, checked } = props;

    return (
      <div className='xpl-toggle-container w-full flex flex-col font-sans text-left font-normal leading-normal text-base'>
        <div className='w-full flex-col mb-2 mt-2'>
          <label className='text-sm font-medium'>{label}</label>
          {!!description && (
            <p className='text-xs font-normal leading-4 text-gray-500'>
              {description}
            </p>
          )}
        </div>
        <div
          className={classNames('w-fit flex items-center h-6', {
            'opacity-90': disabled,
          })}
        >
          <input
            ref={ref}
            className={classNames(`xpl-toggle checked:bg-none`, {
              '!bg-purple-normal hover:!bg-violet-800': checked,
              '!bg-gray-light hover:!bg-gray-400': !checked,
              '!cursor-not-allowed': disabled,
            })}
            type='checkbox'
            {...props}
            readOnly={disabled}
            disabled={disabled || false}
            data-test-id={id}
            checked={!!checked}
          />
          <label htmlFor={id} id='description-label' className='cursor-pointer'>
            {checked ? 'Enabled' : 'Disabled'}
          </label>
        </div>
      </div>
    );
  },
);

export default ToggleInput;
